/** @format */
import { defineAction } from 'actions/actionUtils';

export const fetchUserTeam = defineAction('FETCH_USER_TEAM', 'teams', '', 'GET');
